export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#F0EDE8] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="flex flex-col md:flex-row gap-10 justify-between">
          {/* Brand */}
          <div className="md:w-[35%]">
            <img
              src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/c496e7b7b0d35cec41af6fd81216106e.png"
              alt="IGM Facility Service Logo"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs mb-5">
              Ihr zuverlässiger Partner für Gebäudereinigung, Hausmeisterservice, Grünpflege und Sanierung in ganz NRW.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/igmfacilityservice/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-200 hover:bg-gray-300 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-gray-600 text-base"></i>
              </a>
              <a
                href="https://www.instagram.com/igmfacilityservice/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-200 hover:bg-gray-300 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-gray-600 text-base"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-10">
            <div>
              <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-4">Leistungen</p>
              <ul className="flex flex-col gap-2.5">
                {["Gebäudereinigung", "Hausmeisterservice", "Grünpflege", "Entrümpelung", "Renovierung & Sanierung"].map((item) => (
                  <li key={item}>
                    <button
                      onClick={() => scrollTo("leistungen")}
                      className="text-sm text-gray-600 hover:text-black transition-colors cursor-pointer"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-4">Kontakt</p>
              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-gray-400 text-sm mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm text-gray-600">Industriestr. 37<br />40878 Ratingen</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-gray-400 text-sm flex-shrink-0"></i>
                  <a href="tel:+492102739807" className="text-sm text-gray-600 hover:text-black transition-colors">
                    02102 7398070
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-gray-400 text-sm flex-shrink-0"></i>
                  <a href="mailto:info@igmfacilityservice.de" className="text-sm text-gray-600 hover:text-black transition-colors">
                    info@igmfacilityservice.de
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line text-gray-400 text-sm mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm text-gray-600">
                    Mo–Fr: 10:00–15:00 Uhr<br />
                    Sa: 12:00–15:00 Uhr<br />
                    Notdienst: 24/7
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} IGM Facility Service. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.igmfacilityservice.de/impressum" rel="nofollow" target="_blank" className="text-xs text-gray-400 hover:text-black transition-colors">Impressum</a>
            <a href="https://www.igmfacilityservice.de/datenschutz" rel="nofollow" target="_blank" className="text-xs text-gray-400 hover:text-black transition-colors">Datenschutz</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
